<template>
  <section class="gry-bg py-4">
    <div class="profile">
      <div class="container">
        <div class="row">
          <div class="col-xxl-4 col-xl-5 col-lg-6 col-md-8 mx-auto">
            <div class="card">
              <div class="text-center pt-4">
                <h1 class="h4 fw-600">{{ $t("注册") }}</h1>
              </div>
              <div class="px-4 py-3 py-lg-4">
                <van-form
                  class="form-default"
                  method="POST"
                  role="form"
                  @submit="register"
                >
<!--                  v-if="'1' === paramMapAll['INVITE_CODE_OPEN_SHOW']"-->
                  <div

                      v-if="`,${paramMapAll['REGISTER_PROPS']},`.includes(',codeNumber,')"
                      class="form-group">
<!--                    <label>{{ $t("推广码") }} </label>-->
                    <van-field
                        v-if="disableCode"
                        v-model="registerForm.codeNumber"
                        disabled
                        name="codeNumber"
                        :placeholder="$t(`请输入`)+$t('推广码')"
                        required
                        type="text"
                    />
                    <van-field
                        v-else
                        v-model="registerForm.codeNumber"
                        :rules="[
                        {
                          required: true,
                          message: $t(`请输入`)+$t('推广码')
                        }
                      ]"
                        name="codeNumber"
                        :placeholder="$t('推广码')"
                        type="text"
                    />
                  </div>
<!--                  <van-field-->
<!--                    v-model="registerForm.codeNumber"-->
<!--                    :disabled="codeNumberReadOnly"-->
<!--                    :placeholder="$t('邀请码')"-->
<!--                    :rules="[-->
<!--                      {-->
<!--                        required: true,-->
<!--                        message: $t(`请输入邀请码`),-->
<!--                      },-->
<!--                    ]"-->
<!--                    class="form-group"-->
<!--                  />-->
<!--                  v-if="'1' === paramMapAll['USERNAME_OPEN']"-->

                  <van-field
                    v-if="`,${paramMapAll['REGISTER_PROPS']},`.includes(',username,')"
                    v-model="registerForm.username"
                    :placeholder="$t('用户名')"
                    :rules="[
                      {
                        required: !isPhoneLoginOpen,
                        message: $t(`请输入用户名`),
                      },
                      {
                        pattern: /^.{6,14}$/,
                        message: $t('用户名长度为6_14个字符'),
                        trigger: 'blur',
                      },
                    ]"
                    class="form-group"
                  />
                  <van-field
                      v-if="`,${paramMapAll['REGISTER_PROPS']},`.includes(',email,')"
                      v-model="registerForm.email"
                    :placeholder="$t('邮箱')"
                    :rules="[
                      {
                        required: true,
                        message: $t(`请输入`)+$t(`邮箱`),
                      }
                    ]"
                    class="form-group"
                    type="email"
                  />
                  <van-field
                      v-if="`,${paramMapAll['REGISTER_PROPS']},`.includes(',phone,')"
                      v-model="registerForm.phone"
                    :placeholder="$t('手机号码')"
                    :rules="[
                      {
                        required: true,
                        message: $t(`请输入手机号码`),
                      },
                      {
                        pattern: /^\d{5,}$/,
                        message: $t('手机号码格式错误'),
                        trigger: 'blur',
                      },
                    ]"
                    class="form-group"
                    type="tel"
                  />
<!--                  paramMapAll['SMS_OPEN'] === '1' &&-->
                  <div
                      v-if="`,${paramMapAll['REGISTER_PROPS']},`.includes(',smsCode,')"
                      class="d-flex"
                  >
                    <valid-code
                        :sendType="'REGISTER_CODE'"
                        :placeholder="$t('验证码')"
                        v-model="registerForm.smsCode"
                        :phone="registerForm.phone"
                        :email="registerForm.email"
                    ></valid-code>
                  </div>
                  <van-field
                      v-if="`,${paramMapAll['REGISTER_PROPS']},`.includes(',nickName,')"
                      v-model="registerForm.nickName"
                      :placeholder="$t('昵称')"
                      class="form-group"
                  />
                  <van-field
                      v-if="`,${paramMapAll['REGISTER_PROPS']},`.includes(',password,')"
                      v-model="registerForm.password"
                    :name="$t('password')"
                    :placeholder="$t('密码')"
                    :rules="[
                      {
                        required: true,
                        message: $t(`请输入密码`),
                      },
                      {
                        pattern: /^.{6,16}$/,
                        message: $t('密码长度为6_16个字符'),
                        trigger: 'blur',
                      },
                    ]"
                    class="form-group"
                    type="password"
                  />
                  <van-field
                      v-if="`,${paramMapAll['REGISTER_PROPS']},`.includes(',rePassword,')"
                      v-model="registerForm.rePassword"
                    :placeholder="$t('确认密码')"
                    :rules="[
                      {
                        required: true,
                        message: $t(`请输入确认密码`),
                      },
                      {
                        pattern: /^.{6,16}$/,
                        message: $t('密码长度为6_16个字符'),
                        trigger: 'blur',
                      },
                    ]"
                    class="form-group"
                    type="password"
                  />
                  <van-field
                      v-if="`,${paramMapAll['REGISTER_PROPS']},`.includes(',tkPassword,')"
                      v-model="registerForm.tkPassword"
                    :placeholder="$t('提款密码')"
                    :rules="[
                      {
                        required: true,
                        message: $t(`请输入提款密码`),
                      },
                      {
                        pattern: /^.{4,16}$/,
                        message: $t('提款密码长度为4_16个字符'),
                        trigger: 'blur',
                      },
                    ]"
                    class="form-group"
                    type="password"
                  />
                  <div v-if="captchaOpen" class="d-flex">
                    <van-field
                      v-model="registerForm.captcha"
                      :rules="[
                        {
                          required: true,
                          message: $t('请输入验证码'),
                        },
                      ]"
                      type="number"
                    >
                      <template #button>
                        <img
                          :src="codeImg"
                          alt=""
                          style="height: 24px"
                          @click.stop="createCode"
                        />
                      </template>
                    </van-field>
                  </div>
                  <div class="mb-3" v-if="`,${paramMapAll['REGISTER_PROPS']},`.includes(',register_and_agree_to_the_terms,')">
                    <label class="aiz-checkbox">
                      <input
                        name="checkbox_example_1"
                        required=""
                        type="checkbox"
                      />
                      <span class="opacity-60">{{
                        $t("注册即表示您同意我们的条款和条件")
                      }}</span>
                      <span class="aiz-square-check"></span>
                    </label>
                  </div>

                  <div class="mb-5">
                    <button v-loading="loading"
                      class="btn btn-primary btn-block fw-600"
                      type="submit"
                    >
                      {{ $t("创建账号") }}
                    </button>
                  </div>
                </van-form>

                <div v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',登录页_注册店铺,')" class="text-center">
                  <p class="text-muted mb-0">{{ $t("注册您的商店") + "?" }}</p>
                  <router-link to="/shops/create"
                    >{{ $t("现在申请") }}
                  </router-link>
                </div>
                <div class="text-center">
<!--                  <p class="text-muted mb-0">{{ $t("已经有一个账户") + "?" }}</p>-->
                  <router-link to="/login">{{ $t("登录") }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { getDomainAgentNumber, sendCode } from "@/api/sys/common";
import ValidCode from "@/views/validCode.vue";

export default {
  name:'RegisterView',
  components: {ValidCode},
  computed: {
    ...Vuex.mapGetters(["paramMapAll"]),
    // 是否开启手机号登录
    isPhoneLoginOpen() {
      return "1" === this.paramMapAll["PHONE_LOGIN_OPEN"];
    },
  },
  data() {
    return {
      registerForm: {
        codeNumber: null,
        phone: null,
        username: null,
        password: null,
        rePassword: null,
        tkPassword: null,
        captcha: null,
        smsCode: null,
        nickName: null,
      },
      disableCode: false,
      loading: false,

      showCodeNumber: false,
      codeNumberReadOnly: false,

      captchaOpen: false,
      codeImg: null,

      time: 0,
    };
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  methods: {
    sendCode() {
      if (!this.registerForm.phone) {
        this.$dialog.alert({ message: this.$t("请输入手机号码") });
        return;
      }
      this.time = 60000;
      Cookies.set("Register_Code_Countdown_Time", 60000);
      sendCode({
        isEmail: '1' === this.paramMapAll['EMAIL_OPEN'],
        phone: this.registerForm.phone,
        sendType: "REGISTER_CODE",
      })
        .then(() => {
          this.$dialog.alert({
            message: this.$t("验证码发送成功"),
          });
        })
        .catch(() => {
          this.time = 0;
          Cookies.set("Register_Code_Countdown_Time", 0);
        });
    },
    changeTime(timeData) {
      this.time = timeData.seconds * 1000 + timeData.milliseconds;
      Cookies.set(
        "Register_Code_Countdown_Time",
        timeData.seconds * 1000 + timeData.milliseconds
      );
    },
    createCode() {
      this.codeImg = this.getVerifyCode("LOGIN_CAPTCHA_OPEN");
    },
    async get_agentNumber() {
      this.registerForm["codeNumber"] = this.paramMapAll["INVITE_CODE_DEFAULT"];
      if (this.$route.query.codeNumber) {
        this.showCodeNumber = true;
        this.registerForm["codeNumber"] = this.$route.query.codeNumber;
        this.codeNumberReadOnly = true;
        return;
      }
      // 加载域名代理编号
      const res = await getDomainAgentNumber();
      if (res && res.data) {
        this.showCodeNumber = true;
        this.registerForm["codeNumber"] = res.data;
        this.codeNumberReadOnly = true;
      }
    },
    register() {
      if (this.registerForm.rePassword && this.registerForm.rePassword !== this.registerForm.password) {
        this.$toast.fail(this.$t("确认密码不一致"));
        return;
      }
      if (
        this.paramMapAll["SYSTEM_VERSION"] === "L_47" &&
        this.registerForm.tkPassword
      ) {
        const reg = /^[0-9]+.?[0-9]*$/;
        if (!reg.test(this.registerForm.tkPassword)) {
          this.$toast.fail(this.$t("提款密码必须为数字"));
          return;
        }
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      let form = {...this.registerForm};
      // if ("1" !== this.paramMapAll["USERNAME_OPEN"]) {
      //   form.username = this.registerForm.phone;
      // }
      let user = Object.assign({}, form);
      this.$store
        .dispatch("user/register", user)
        .then(() => {
          this.$toast.success(this.$t("注册成功"));
          this.$router.push({ path: "/" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.time = parseInt(Cookies.get("Register_Code_Countdown_Time"));
    this.get_agentNumber();
    this.captchaOpen = "1" === this.paramMapAll["REGISTER_CAPTCHA_OPEN"];
    if (this.captchaOpen) {
      this.createCode();
    }
    this.disableCode = !!this.$route.query.codeNumber;
  },
};
</script>
